import { useEffect, useState } from "react";
import { Crown, User, KeyRound } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { ChangePin, AdminEmail } from "@/pages/Settings";
import { TokenUsage } from "@/components/TokenUsage";

const Accounts = () => {
  const { user } = useAuth();
  const [users, setUsers] = useState([]);
  useEffect(() => { api.get("/users").then((r) => setUsers(r.data)).catch(() => setUsers([])); }, []);
  return (
    <div className="grid grid-cols-2 gap-3" data-testid="user-menu-accounts">
      {users.map((u) => (
        <div key={u.id} className={`rounded-2xl border p-3 ${u.id === user.id ? "border-pink-300 bg-pink-50" : "border-pink-100 bg-white"}`} data-testid={`user-menu-account-${u.role}`}>
          <div className="flex items-center gap-2 font-semibold text-gray-800">
            {u.role === "master" ? <Crown className="w-4 h-4 text-amber-400" /> : <User className="w-4 h-4 text-sky-400" />} {u.name}
          </div>
          <p className="text-xs text-gray-500 mt-1 flex items-center gap-1"><KeyRound className="w-3 h-3" /> Masuk pakai PIN {u.role === "master" ? "6 digit" : "4-6 digit"}</p>
          {u.id === user.id && <p className="text-[10px] text-pink-500 font-semibold mt-1">Sedang dipakai</p>}
        </div>
      ))}
    </div>
  );
};

export const UserMenu = ({ open, onClose }) => {
  const { user } = useAuth();
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto rounded-3xl bg-[#FFF7FA]" data-testid="user-menu-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading text-2xl">Akun windiku</DialogTitle>
          <DialogDescription>Hanya 2 akun: Admin dan Windi, masing-masing masuk pakai PIN.</DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <Accounts />
          <ChangePin />
          {user.role === "master" && <AdminEmail />}
          <TokenUsage />
        </div>
      </DialogContent>
    </Dialog>
  );
};
